import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initSentry } from './config/sentry';
import { App } from './App';
import './styles/global.css';

// Initialize Sentry error tracking before rendering
initSentry();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found. Ensure index.html contains <div id="root"></div>');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Fade out the loading screen after React has painted
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    const loader = document.getElementById('app-loading');
    if (!loader) return;

    loader.classList.add('fade-out');

    const remove = () => loader.remove();
    loader.addEventListener('transitionend', remove, { once: true });
    // Safety timeout in case transitionend doesn't fire
    setTimeout(remove, 1000);
  });
});
